import Vue from "vue";
import Router from "vue-router";

import { routerMiddleware } from "@/_shared/middlewares";
import DefaultLayout from "@/_shared/layouts/DefaultLayout";
import PageNotFoundLayout from "@/_shared/layouts/PageNotFoundLayout";

import authorizationRoutes from "@/authorization/routes";
import userRoutes from "@/user/routes";
import stockRoutes from "@/stock/routes";
import businessRoutes from "@/business/routes";

Vue.use(Router);

const router = new Router({
  routes: [
    ...authorizationRoutes,
    {
      path: "/",
      component: DefaultLayout,
      children: [
        ...userRoutes,
        ...stockRoutes,
        ...businessRoutes,
      ],
      beforeEnter: routerMiddleware.checkToken,
    },
    {
      path: '/:pathMatch(.*)*',
      component: PageNotFoundLayout,
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/_shared/router.js